import styles from "@/styles/shop-info/day-change-mind.module.scss";
import Image from "next/image";

import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
const imageDomain = publicRuntimeConfig.imageDomain;

export default function CompFastDeliveryContent() {
  return (
    <div className={styles["comp-day-change-mind"]}>
      <Image
        className={styles["banner-img"]}
        style={{ display: "block", margin: "0 auto" }}
        src={`${imageDomain}/legal/fast-delivery-banner.png`}
        alt={"crazy-points-banner"}
        width={800}
        height={139}
      ></Image>
      <div className={`${styles["ask-title"]} padding-top-16`}>
        Fast Delivery for Online Shopping in Australia
      </div>
      <div className={`${styles["answer-desc"]}`}>
        When you order online at CrazySales, we get your shopping delivered to
        your home as fast as humanly possible. Over 96% of our orders are
        shipped the next business day or earlier! We make sure to use the right
        delivery service for all of our online shopping home delivery, and yes,
        we do have express delivery options if you need them.
      </div>
      <div className={`${styles["answer-desc"]} padding-top-10`}>
        To save on delivery, your smaller purchases are automatically shipped
        together! Simply look for the <span className={styles['link']}>&quot;Combine Shipping and Save&quot;</span> icon when
        selecting products, and we&apos;ll even show you just how much you&apos;re saving
        on shipping when you view your shopping cart. It&apos;s that easy!
      </div>
      <div className={`${styles["answer-desc"]} padding-top-10`}>
        We pride ourselves on our reliability and so all deliveries are made
        with full transit insurance. We always include the cost of insurance in
        the shipping cost, so there are never any hidden fees.
      </div>
      <div className={`${styles["answer-desc"]} padding-top-10`}>
        Depending on your location and the type of goods you&apos;ve ordered from our
        online shop, we use one of three shipping services. For orders under
        22kg, we use Australia Post&apos;s eParcel delivery service, Express Post and
        Australian Air Express. All are highly affordable and offer tracking of
        your order.
      </div>
      <div className={`${styles["answer-desc"]} padding-top-10`}>
        For heavy orders over 22kg, we use Toll IPEC, who specialise in fast
        Australia-wide cargo delivery of heavy goods. If you need your online
        shopping order quickly, we offer delivery express courtesy of Australian
        Express Post DHL and EMS for remote areas. We hope you&apos;ll enjoy shopping
        with us, and we can&apos;t wait to ship your order!
      </div>

      <Image
        className={`${styles["banner-img"]}`}
        style={{ display: "block", margin: "24px auto" }}
        src={`${imageDomain}/legal/fast-delivery-pic.gif`}
        alt={"crazy-points-banner"}
        width={800}
        height={139}
      ></Image>
    </div>
  );
}
